<script>
import Encoding from 'encoding-japanese'
import BaseButton from '@/components/pc/radio/ipradio/atoms/BaseButton.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
    name: 'StatusSettingVue2',
    components: {
        BaseButton,
        SettingGroup,
    },
    data() {
        const radioSettings = useRadioSettingsStore()
        return {
            radioSettings,
            // ストアに仮保存済みの端末設定情報を取得する
            setting: radioSettings.getTempSetting(),
            form: {
                text: {
                    statusListText: [],
                    statusAddText: null,
                    prevStatusText: {
                        list: [],
                        add: null,
                    },
                },
            },
            rules: {
                statusListText: [{ validator: function() {}, trigger: ['change', 'blur'] }], // 後で this にバインドして差し替える
                statusAddText: [{ validator: function() {}, trigger: 'change' }],
            },
        }
    },
    computed: {
        disableSave() {
            const list = Array.isArray(this.form.text.statusListText) ? this.form.text.statusListText : []
            return list.length === 0 || list.some((text) => !text || String(text).trim() === '')
        },
    },
    created() {
        // バリデータに this をバインド
        this.rules.statusListText[0].validator = this.validateRequired
        this.rules.statusAddText[0].validator = this.validateStatusText

        // setting -> form 反映
        this.transSetting2Form()

        // watch（deep, post 相当）
        this.$watch(
            'form',
            () => {
                this.transForm2Setting()
                this.radioSettings.saveTempSetting(this.setting)
            },
            { deep: true, immediate: false }
        )
        this.$watch(
            'disableSave',
            (val) => {
                this.$emit('disableSave', val)
            },
            { immediate: true }
        )
    },
    methods: {
        validateRequired(rule, value, callback) {
            if (!value || String(value).trim() === '') {
                callback(new Error('値を指定してください。'))
                return
            }
            callback()
        },

        // 最大半角16文字（全角8文字）
        validateStatusText(rule, value, callback) {
            if (!value) return callback();

            // 定義（validateCategoryJIS と同じ）
            const allowedKu = (ku) => (ku >= 1 && ku <= 8) || ku === 13 || (ku >= 16 && ku <= 84);

            const encodeSjis = (s) => Encoding.convert(Encoding.stringToCode(s), { to: 'SJIS', from: 'UNICODE', type: 'array' });

            const decodeSjis = (bytes) => Encoding.codeToString(Encoding.convert(bytes, { to: 'UNICODE', from: 'SJIS', type: 'array' }));

            const sjisToKuTen = (b1, b2) => {
                let j1 =
                (b1 >= 0x81 && b1 <= 0x9F) ? (b1 - 0x81) * 2 + 0x21 :
                (b1 >= 0xE0 && b1 <= 0xEF) ? (b1 - 0xC1) * 2 + 0x21 :
                null;
                if (j1 == null) return null;

                let j2;
                if (b2 >= 0x9F && b2 <= 0xFC) { j1 += 1; j2 = b2 - 0x7E; }
                else if (b2 >= 0x40 && b2 <= 0x7E) j2 = b2 - 0x1F;
                else if (b2 >= 0x80 && b2 <= 0x9E) j2 = b2 - 0x20;
                else return null;

                const ku = j1 - 0x20, ten = j2 - 0x20;
                return (ku >= 1 && ku <= 94 && ten >= 1 && ten <= 94) ? { ku, ten } : null;
            };

            const sanitizeOne = (input) => {
                if (!input) return '';

                let out = '';
                let used = 0;

                for (const ch of String(input)) {
                    const cp = ch.codePointAt(0);
                    if (cp < 0x20 && ch !== ' ') continue;

                    let bytes;
                    try { bytes = encodeSjis(ch); } catch { continue; }
                    if (!bytes || bytes.length < 1 || bytes.length > 2) continue;

                    // 往復一致（置換・互換変換を排除）
                    if (decodeSjis(bytes) !== ch) continue;

                    if (bytes.length === 1) {
                        const b = bytes[0];
                        if (!((b >= 0x20 && b <= 0x7E) || (b >= 0xA1 && b <= 0xDF))) continue;
                    } else {
                        const kt = sjisToKuTen(bytes[0], bytes[1]);
                        if (!kt || !allowedKu(kt.ku)) continue;
                    }
                    if (used + bytes.length > 16) break; // SJIS換算16バイト上限（入らない最初の文字で打ち切り）
                    out += ch;
                    used += bytes.length;
                }

                return out;
            };
            // 定義

            // value が配列ならリスト編集（変更された1要素だけをサニタイズして反映）
            if (Array.isArray(value)) {

                const prev = Array.isArray(this.form.text.prevStatusText.list) ? this.form.text.prevStatusText.list : [];
                const changedIdx = value.findIndex((text, idx) => text !== prev[idx]);
                if (changedIdx === -1) return callback();

                const sanitized = sanitizeOne(value[changedIdx]);
                this.$set(this.form.text.prevStatusText.list, changedIdx, sanitized);
                this.$set(this.form.text.statusListText, changedIdx, sanitized);
                return callback();
            }

            // value が文字列なら追加行（statusAddText）
            const sanitized = sanitizeOne(value);
            this.form.text.prevStatusText.add = sanitized;
            this.form.text.statusAddText = sanitized;
            callback();
        },

        transForm2Setting() {
            const data = this.setting.SelCall
            // Vue2 では structuredClone / toRaw は無いので JSON deep copy
            // console.log('============================')
            // console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.SelCall.StatusList)))

            data.StatusList = this.form.text.statusListText

            // console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.SelCall.StatusList)))
        },

        transSetting2Form() {
            const data = this.setting.SelCall
            // console.log('============================')
            // console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

            this.form.text.statusListText = data.StatusList || []
            if (this.form.text.prevStatusText.list.length === 0) {
                this.form.text.prevStatusText.list = [...(data.StatusList || [])]
            }

            // console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
        },

        handleDeleteStatus(idx) {
            this.form.text.statusListText.splice(idx, 1)
            this.form.text.prevStatusText.list.splice(idx, 1)
        },

        handleAddStatus() {
            if (this.form.text.statusAddText && this.form.text.statusListText.length < 20) {
                this.form.text.statusListText.push(this.form.text.statusAddText)
                this.form.text.prevStatusText.list.push(this.form.text.statusAddText)
                this.form.text.statusAddText = ''
            }
        },
    },
}
</script>

<template>
    <div>
        <SettingGroup title="定型ステータス名">
            <el-form :model="form.text" :rules="rules">
                <div class="rowLine" v-for="(text, idx) in form.text.statusListText" :key="idx">
                    <el-form-item
                        class="rowInput"
                        :prop="`statusListText.${idx}`"
                        :rules="rules.statusListText"
                    >
                        <el-input
                            v-model="form.text.statusListText[idx]"
                            :disabled="false"
                            placeholder="入力してください"
                            @input="validateStatusText(null, form.text.statusListText, () => {})"
                        />
                    </el-form-item>
                    <div class="rowAction">
                        <BaseButton
                            type="default"
                            :transparent="true"
                            :disable="false"
                            @click="handleDeleteStatus(idx)"
                        >
                            <img src="@/assets/images/delete.svg" alt="削除" class="deleteIcon" />
                        </BaseButton>
                    </div>
                </div>

                <div class="rowLine" v-if="form.text.statusListText.length < 20">
                    <el-form-item class="rowInput" prop="statusAddText">
                        <el-input
                            v-model="form.text.statusAddText"
                            :disabled="false"
                            placeholder="入力してください"
                            @input="validateStatusText(null, form.text.statusAddText, () => {})"
                        />
                    </el-form-item>
                    <div class="rowAction">
                        <BaseButton
                            label="追加"
                            class="listBtn"
                            type="primary"
                            :disable="!form.text.statusAddText"
                            @click="handleAddStatus"
                        />
                    </div>
                </div>
            </el-form>
        </SettingGroup>
    </div>
</template>

<style scoped>
.rowLine {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.rowInput {
    flex: 1;
}
.rowAction {
    height: 40px;
    display: flex;
    align-items: center;
}

/* ボタンは左に少し余白。auto はやめる */
.listBtn {
    margin: 0 0 0 8px;
}

.no-border {
    background: transparent;
    border: none !important;
    box-shadow: none !important;
}

.deleteIcon {
    width: 30px;
    height: 30px;
}
</style>
